import React, {useState} from "react"
import {Link} from "react-router-dom";
import DoneIcon from '../../assets/icons/done.svg';
import CancelIcon from '../../assets/icons/cancel.svg';
import RefundedIcon from '../../assets/icons/refunded.svg';
import {PopupboxManager, PopupboxContainer} from 'react-popupbox';
import {deleteSlide} from "../../services/slides";

function SlideTables(props){
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const popupboxConfig = {
        titleBar: {
            enable: true,
            text: 'Please confirm'
        },
        overlayClose:true,
        fadeIn: true,
        fadeInSpeed: 500
    }

    function deleteSingleSlide(id){
        deleteSlide(id,props.token).then((response) => {
            setData(response.data);
        })
            .catch((err) => {
                console.log(err.message);
                setError(err.message)
            });
        PopupboxManager.close()
    }


    function openPop(id){
        const content = (
            <div>
                <h4>are you sure to delete Slide id : {id} ? </h4>
                <row>
                    <button onClick={() => deleteSingleSlide(id)} className="btn btn-danger warning-btn"> Delete </button>
                    <button onClick={PopupboxManager.close}  className="btn btn-warning warning-btn"> Cancel</button>
                </row>
            </div>
        )
        PopupboxManager.open({ content:content, config: popupboxConfig})
    }
    return(
        <div>
            <PopupboxContainer/>
            {error ? <div className="alert alert-danger" role="alert">
                {error}
            </div> : null}
            {data ? <div className="alert alert-success" role="alert">
                Slide with ID {data.data.slide.id} has been deleted
            </div> : null}
            <table>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>TITLE</th>
                        <th>SUBTITLE</th>
                        <th>ACTIONS</th>
                    </tr>
                </thead>

                {props.slide.length !== 0 ?
                    <tbody>
                    {props.slide.map((slide, index) => (
                        <tr key={index}>
                            <td><span>{slide.id}</span></td>

                            {/*<td>
                                        <div>
                                            <img
                                                src={order.avatar}
                                                className='dashboard-content-avatar'
                                                alt={order.first_name + ' ' +order.last_name} />
                                            <span>{order.first_name} {order.last_name}</span>
                                        </div>
                                    </td>*/}
                            <td><span>{slide.title}</span></td>
                            <td><span>{slide.subtitle}</span></td>
                            <td><span><Link to="/singleslide" state={{id: slide.id}}><i
                                className="bi bi-pen">edit</i></Link><br/>
                            <i onClick={() => openPop(slide.id)} className="bi bi-trash">delete</i>
                            </span></td>
                        </tr>
                    ))}
                    </tbody>
                    : null}
            </table>
        </div>
    )

}

export default SlideTables